import PropTypes from 'prop-types';

import GaugeComponent from 'react-gauge-component';

const Gauge = ({ title, value, limitLow, limitHigh, minValue, maxValue }) => {
  const colorRed = "#EA4228"
  const colorGreen = "#5BE12C"
  const colorBlue = "#083D77"
  const getSubarcs = function (limitLow, limitHigh, minValue, maxValue) {
    let sa = []
    if (limitLow === minValue && limitHigh === maxValue) {
      return [{ limit: limitLow, color: colorGreen }]
    }
    if (limitLow === minValue) {
      sa.push({ color: colorGreen, limit: limitHigh })
      sa.push({ color: colorRed, limit: maxValue })
      return sa
    }
    if (limitHigh === maxValue) {
      sa.push({ limit: limitLow, color: colorBlue })
      sa.push({ color: colorGreen, limit: maxValue})
      return sa
    }

    if (limitLow > minValue) {
      sa.push({ limit: limitLow, color: colorBlue })
    }
    sa.push({ limit: limitHigh, color: colorGreen })
    if (limitHigh < maxValue) {
      sa.push({ limit: maxValue, color: colorRed })
    }
    return sa
  }
  const subArcs = getSubarcs(limitLow, limitHigh, minValue, maxValue);

  return (
    <div className="rounded-xl pb-4">
      <div className="text-center text-cyan-800 text-2xl pt-2">
        {title}
      </div>
      <GaugeComponent
        type="semicircle"
        arc={{
          padding: 0.02,
          subArcs: subArcs,
        }}
        minValue={minValue}
        maxValue={maxValue}
        unit=""
        pointer={{ type: "blob", animationDelay: 0 }}
        value={value}
        labels={{
          valueLabel: {
            matchColorWithArc: true,
            formatTextValue: (value) => {
              return value;
            },
            /*
          formatTextValue: (value: any) => string: The format of the value label. Default: undefined.
          maxDecimalDigits: number: this is the number of decimal digits the value will round up to. Default: 2
          */
            style: { fontSize: "35px", textShadow: "none" },
            hide: false,
          }
        }}
      />

    </div>
  );
};

Gauge.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  limitLow: PropTypes.number.isRequired,
  limitHigh: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
};

export default Gauge;
